<template>
    <div>
        <div class="col-sm-12 mb-4">
            <div class="row pt-4">
                <div class="d-flex col-md-6 ">
                    <div class="d-flex w-100">
                        <input class="glued-right bg-lighter w-100" type="text" v-model="searchString" placeholder="Search agent name">
                        <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                    </div>
                </div>

                <div class="d-flex justify-content-end col-md-6">
                    <export :exportOptions="exportOptions"></export>
                </div>
            </div>
        </div>

        <div class="mt-4 p-4 text-center" v-if="getIsLoadingAssociatedAgent">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredAgents" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { peopleMixin } from '@/mixins/people'
    
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Loader from '@/tools/loaders/loader1'
    import Export from '@/tools/ExportV2'
    import XLSX from 'xlsx'

    export default {
        data() {
            return {
                searchString: null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        image: this.formatImage,
                        name: this.formatName,
                        role: this.formatRole,
                        status: this.formatStatus,
                    },
                    customRowEvent: this.view,
                    customClassCell: {
                        name: 'pointer',
                        phone: 'pointer',
                        email: 'pointer',
                        status: 'pointer',
                    },
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove
                        }
                    ],
                },
                exportOptions: [
                    {
                        label: 'Excel',
                        action: this.exportAgentsBtn
                    }
                ],
                closeExportOptions: false
            }
        },
        computed: {
            ...mapGetters([
                'getAgents',
                'account',
                'getIsLoadingAssociatedAgent'
            ]),
            allAgents() {
                return this.getAgents;
            },
            header() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: {
                        image: '',
                        name: 'Name',
                        phone: 'Phone',
                        email: 'Email',
                        status: 'Status',
                    },
                };
            },
            filteredAgents() {
                let output = this.getAgents;

                if (this.searchString != null) {
                    output = output.filter(agent => {
                        return agent.brandName.toLowerCase().includes(this.searchString.toLowerCase()) || (agent.email && agent.email.toLowerCase().includes(this.searchString.toLowerCase()));
                    });
                }

                return output;
            }
        },
        mixins: [
            peopleMixin
        ],
        methods: {
            ...mapActions([
                'openModal',
                'removeItem',
                'setSelectedPerson',
                'inviteAgent',
                'connectToAgent',
                'downloadAgents',
                'exportAgents',
                'initAgents'
            ]),
            formatRole(person) {
                return person.role ? person.role.label : '';
            },
            formatImage(person) {
                return person.image ? '<img style="max-width: 100px; max-height: 100px;" src="' + person.image + '" alt="' + person.name + '">' : '';
            },
            formatName(person) {
                    return `<strong>` + person.brandName + `</strong>`;
            },
            formatStatus(person) {
                if (person.isLoading) {
                    return '<div class="loaderHolder"><div class="loader">Loading...</div></div>';
                } else {
                    return '<div style="width: 150px" class="radius-normal fs-smaller lightest radius-stadium '+this.peopleInviteStatus(person).colorClass+' p-2 font-weight-600 text-center">'+this.peopleInviteStatus(person).label+'</div>';
                }
            },
            view(person) {
                this.setSelectedPerson(person);
                this.openModal('AgentView');
            },
            remove(item) {
                if (item.isOTA) {
                    this.$dialog.alert('\
                        <div class="fs-larg font-weight-600 mb-4">This action is not available for this agent.</div>\
                        <div>If you wish to cancel protocol connection with '+item.brandName+' please contact the support team</div>', {
                            okText:'Ok'
                        })
                        .then(() => {})
                        .catch(() => {});
                    return false;
                }

                this.removeItem({
                    table: 'agents',
                    object: 'AgentProtocol',
                    module: 'people',
                    fields: { supplierId: this.account.supplierId, Agent: item, by: this.account.name, }
                });
            },
            exportAgentsBtn() {
                const now = new Date();
                const [monthName, day, hour, minute, seconds] = [
                    now.toLocaleString("en-US", { month: "long" }),
                    now.getDate(),
                    now.getHours(),
                    now.getMinutes(),
                    now.getSeconds()
                ];

                const padWithZero = (number) => String(number).padStart(2, '0');
                const filename = `Agents_${monthName}_${padWithZero(day)}-${padWithZero(hour)}_${padWithZero(minute)}_${padWithZero(seconds)}.xlsx`;
       
                //  * XLSX created from the backend
                this.exportAgents().then(response => {
                    window.URL = window.URL || window.webkitURL;
                    const headers = response.headers;
                    const blob = new Blob([response.data],{type:headers['content-type']});
                    const link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                })
            }
        },
        components: {
            List,
            Search,
            Export,
            Loader,
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .custom-name {
        a, a:hover {
            color: $dark;
        }
    }
</style>



// WEBPACK FOOTER //
// PeopleAgents.vue?21936335